/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 08/12/2024 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { Box, Tooltip, Typography } from "@mui/material";

export default function SemaforoStatus({ status = "PE" }) {
  const normalizedStatus = status?.toString()?.trim()?.toUpperCase() || "SIN ESTATUS";
  const isGreenStatus = ['PENDIENTE', 'PE', 'CAPTURA', 'EC', 'EN PROCESO'].includes(normalizedStatus);
  const isYellowStatus = ['ENTREGADO', 'ENTREGADA', 'TERMINADA', 'TERMINAD=', 'TERMINADO', 'TR'].includes(normalizedStatus);
  const isRedStatus = ['CANCELADA', 'CANCELADO', 'CA'].includes(normalizedStatus);

  const statusColor = isGreenStatus ? '#2E7D32' : isRedStatus ? '#D32F2F' : isYellowStatus ? '#F57C00' : '#616161';
  const bgColor = isGreenStatus ? '#E8F5E9' : isRedStatus ? '#FFEBEE' : isYellowStatus ? '#FFF3E0' : '#F5F5F5';

  return (
    <Tooltip
      title={
        normalizedStatus.length > 0
          ? `Estatus: ${normalizedStatus}`
          : "Estatus"
      }
    >
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem',
          padding: '0.45rem 0.75rem',
          border: '1px solid #D1D1D1',
          borderRadius: '999px',
          backgroundColor: bgColor,
          minWidth: '180px',
          boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.03)',
          color: statusColor,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            backgroundColor: statusColor,
            boxShadow: '0 0 0 1px rgba(0,0,0,0.08)',
          }}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0, alignItems: 'center' }}>
          <Typography
            variant="caption"
            sx={{
              color: '#555',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              fontWeight: 700,
            }}
          >
            Estado
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: statusColor,
              fontWeight: 700,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '120px',
            }}
          >
            {normalizedStatus}
          </Typography>
        </Box>
      </Box>
    </Tooltip>
  );
}
